import { render } from "./CarCreateCheck.vue?vue&type=template&id=21432cf8"
import script from "./CarCreateCheck.vue?vue&type=script&lang=js"
export * from "./CarCreateCheck.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__